import React from "react";

const DashboardIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.08742 7H16.9217C17.1809 7 17.3921 7.21122 17.3921 7.47044V14.6326C17.3921 14.8919 17.1809 15.1031 16.9217 15.1031H6.97044C6.71122 15.1031 6.5 14.8919 6.5 14.6326V9.58742C6.5 8.1569 7.6617 7 9.08742 7Z"
        fill="#57CC99"
      />

      <path d="M22.9125 8.2001C23.6757 8.2001 24.2998 8.82415 24.2998 9.58742V13.903H20.0322V8.1953H22.9077M22.9125 7H19.3074C19.0481 7 18.8369 7.21122 18.8369 7.47044V14.6326C18.8369 14.8919 19.0481 15.1031 19.3074 15.1031H25.0294C25.2887 15.1031 25.4999 14.8919 25.4999 14.6326V9.58742C25.4999 8.1569 24.343 7 22.9125 7Z" />
      <path d="M24.2998 17.7433V22.0589C24.2998 22.8221 23.6758 23.4462 22.9125 23.4462H15.8031V17.7385H24.2998M25.0247 16.5432H15.0735C14.8142 16.5432 14.603 16.7544 14.603 17.0137V24.1759C14.603 24.4351 14.8142 24.6463 15.0735 24.6463H22.9077C24.3382 24.6463 25.4951 23.4894 25.4951 22.0589V17.0137C25.4951 16.7544 25.2839 16.5432 25.0247 16.5432Z" />
      <path d="M11.9629 17.7433V23.451H9.08742C8.32415 23.451 7.7001 22.8269 7.7001 22.0637V17.7481H11.9677M12.6925 16.5432H6.97044C6.71122 16.5432 6.5 16.7544 6.5 17.0137V22.0589C6.5 23.4894 7.6569 24.6463 9.08742 24.6463H12.6925C12.9517 24.6463 13.163 24.4351 13.163 24.1759V17.0137C13.163 16.7544 12.9517 16.5432 12.6925 16.5432Z" />
    </svg>
  );
};

export default DashboardIcon;
